import type { MutableRefObject } from 'react';
import type Scrollbars from 'react-custom-scrollbars-2';

/**
 * Get ref to Scrollbars view element
 *
 * This helper relies on the fact that scrollbars' renderView ref leads to a div element,
 * so it cannot be used for Scrollbars in general.
 */
export const makeScrollbarsViewRef =
  (ref: MutableRefObject<HTMLDivElement | null>) =>
  (scrollbars: Scrollbars | null): void => {
    // Scrollbars.view is a field undocumented in @types that contains ref to the view.
    ref.current = (scrollbars as any)?.view ?? null;
  };
